<template>
  <div class="evaluation-container">
    <div class="card-list">
      <!-- 人才评估评价卡片 -->
      <div class="card-item">
        <div class="card-content">
          <h3 class="card-title">人才评估评价</h3>
          <p class="card-desc">
            公司评估评价团队完成了成都高新区“岷山行动”计划、宜宾“江源行动”计划、金牛区、德阳市、雅安市等 100 余个重大招引项目开展了技术尽调、中期评估、验收评估等验证和评估工作。
          </p>
        </div>
      </div>

      <!-- 新研机构评价卡片 -->
      <div class="card-item-two">
        <div class="card-content">
          <h3 class="card-title">新研机构评价</h3>
          <p class="card-desc">
            公司服务团队参与了新研机构国家标准的制定，成功完成重庆两江新区引进新型研发机构评估、成都高新区常态化项目招引评估、双流区引进研究院、雅安市等五十余个等政府委托的机构评估。
          </p>
        </div>
      </div>

      <!-- 科技成果评价卡片 -->
      <div class="card-item-three">
        <div class="card-content">
          <h3 class="card-title">科技成果评价</h3>
          <p class="card-desc">
            公司已累计组织500余场高水平评价会议，凭借严谨的评价流程和权威的专家团队，所评项目获得多个国家级、省部级科技奖励。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EvaluationCards',
  data() {
    return {}
  }
}
</script>

<style scoped>
.evaluation-container {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 40px 20px;
  box-sizing: border-box;
}

.card-list {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content:space-between;
}

.card-item {
  flex: 1;
  min-width: 280px;
  max-width: 400px;
  aspect-ratio: 5 / 7;
  background: url("~@/assets/images/fw1.png") no-repeat center center;
  background-size: cover;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}
.card-item-two {
  flex: 1;
  min-width: 280px;
  max-width: 400px;
  aspect-ratio: 5 / 7;
  background: url("~@/assets/images/fu2.png") no-repeat center center;
  background-size: cover;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}
.card-item-three {
  flex: 1;
  min-width: 280px;
  max-width: 400px;
  aspect-ratio: 5 / 7;
  background: url("~@/assets/images/fu3.png") no-repeat center center;
  background-size: cover;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}
.card-content {
  position: absolute;
  top: 53%;
  width: 88%;
  padding: 0 10px;
  box-sizing: border-box;
}
.card-title {
  font-size: 28px;
  font-weight: 600;
  color: #003399;
  margin: 0 0 14px 0;
  line-height: 1.3;
}
.card-desc {
  font-size: 15px;
  color: #333;
  line-height: 1.7;
  margin: 0;
}
/* 中等屏幕 */
@media (max-width: 1100px) {
  .card-title { font-size: 24px; }
  .card-desc { font-size: 14px; }
}

/* 平板 */
@media (max-width: 768px) {
  .card-item {
    min-width: 100%;
    max-width: 100%;
  }
  .card-title { font-size: 22px; }
  .card-desc { font-size: 13px; }
}

/* 手机 */
@media (max-width: 480px) {
  .card-title { font-size: 19px; }
  .card-desc { font-size: 12px; line-height: 1.6; }
}

/* 小屏手机 */
@media (max-width: 360px) {
  .card-title { font-size: 17px; }
  .card-desc { font-size: 11px; }
}
</style>